import { gql } from "@apollo/client";
export const createAgreementReportMutation = gql`
  mutation CreateAgreementReport($input: CreateAgreementReportInput!) {
    createAgreementReport(input: $input) {
      reportCreated
    }
  }
`;
